import { Recipe } from '../../api/Recipe';

export const RECIPES_PER_PAGE = 10;

export const getRecipeSortKey = (sortField: string, sortDirection: 'asc' | 'desc') =>
  `${sortField}_${sortDirection}`;

export const isDefaultRecipeSort = (sortField: string, sortDirection: 'asc' | 'desc') =>
  sortField === 'created_at' && sortDirection === 'desc';

export const recipeMatchesFilters = (
  recipe: Recipe,
  selectedTagIds: number[],
  selectedAuthorIds: number[]
): boolean => {
  const matchesAuthors = selectedAuthorIds.length === 0 || selectedAuthorIds.includes(recipe.author_id);
  const matchesTags = selectedTagIds.length === 0 || !!recipe.tags?.some((tag) => selectedTagIds.includes(tag.id));

  return matchesAuthors && matchesTags;
};

export const mergeRecipePages = (previousRecipes: Recipe[], nextRecipes: Recipe[]): Recipe[] => {
  const uniqueNextRecipes = nextRecipes.filter(
    (newRecipe) => !previousRecipes.some((previousRecipe) => previousRecipe.id === newRecipe.id)
  );

  return [...previousRecipes, ...uniqueNextRecipes];
};
